export default __webpack_public_path__ + "static/media/ic_popup_caret.f8c4c4a1.svg";